import { AxiosResponse } from 'axios';
import { APIClient } from 'services/helpers/api_helper';

import * as url from 'services/helpers/url_helper';
import {
  AddPromoResponse,
  DeletePromoBatchResponse,
  GetAllPromoResponse,
  GetOnePromoResponse,
  GetPromotionsRequest,
  PromoFormValues,
  UpdatePromoResponse,
} from 'types/promotion/promotionTypes';
import { mapPromoFormValuesToPromo } from 'utils/mappers/promoMapper';

export const api = new APIClient();

export const getAllPromotions = async () => {
  try {
    const response: GetAllPromoResponse = await api.get(url.GET_ALL_PROMOTIONS);
    if (response) {
      const { message, error_code, data } = response;
      if (message === 'OK' && error_code === 0) {
        return data;
      } else {
        return { total: 0, promotions: [] };
      }
    }
    return { total: 0, promotions: [] };
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getPromotionsList = async (
  store_ids: number[],
  keyword = '',
  active: number | null = null,
  promotion_type: number | null = null,
  limit = 10,
  page = 1,
  sort_by = 'promotion_id',
  sort_order = 'desc'
) => {
  const req: GetPromotionsRequest = {
    store_ids: store_ids,
    keyword: keyword,
    limit: limit,
    page: page,
    sort_by: sort_by,
    sort_order: sort_order,
  };

  if (active !== null) {
    req.active = active;
  }

  if (promotion_type !== null) {
    req.promotion_type = promotion_type;
  }
  try {
    const response: GetAllPromoResponse = await api.get(
      url.GET_PROMOTION_LIST,
      req
    );
    if (response) {
      const { message, error_code, data } = response;
      if (message === 'OK' && error_code === 0) {
        return data;
      } else {
        return { total: 0, promotions: [] };
      }
    }
    return { total: 0, promotions: [] };
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getPromotionByID = async (id: string) => {
  try {
    const response: GetOnePromoResponse = await api.get(
      url.GET_PROMOTION_BY_ID + id
    );
    if (response) {
      const { message, error_code, data } = response;
      if (message === 'OK' && error_code === 0) {
        return data;
      } else {
        return null;
      }
    }
    return null;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postAddPromotion = async (FormData: PromoFormValues) => {
  try {
    const transformedData = await mapPromoFormValuesToPromo(FormData);
    const response: AxiosResponse<AddPromoResponse> = await api.create(
      url.POST_ADD_PROMOTION,
      transformedData
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const putUpdatePromotion = async (
  FormData: PromoFormValues,
  id: string
) => {
  try {
    const transformedData = await mapPromoFormValuesToPromo(FormData);
    const response: AxiosResponse<UpdatePromoResponse> = await api.put(
      url.PUT_UPDATE_PROMOTION + id,
      transformedData
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const deletePromotionBatch = async (promotionIDs: number[]) => {
  try {
    const body = {
      promotion_ids: promotionIDs,
    };
    const response: AxiosResponse<DeletePromoBatchResponse> = await api.delete(
      url.DELETE_PROMOTIONS_BATCH,
      {
        data: body,
      }
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
